import React, { useState } from "react";
import axios from "axios";
import "./PopupQuickview.css";
import { t } from "i18next";

const PopupQuickview = ({ product, addToCart, handleCloseClick }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [formStatus, setFormStatus] = useState(null);

  if (!product) return null;

  // Helper function to split label and value by ":"
  const splitInfo = (text) => {
    if (!text) return { label: "", value: "" };
    const parts = text.split(":");
    if (parts.length === 2) {
      return {
        label: parts[0].trim(),
        value: parts[1].trim(),
      };
    }
    return { label: "", value: text.trim() };
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus(null);

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/contact`, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: `Quotation request for product: ${product.name}`,
      });

      setFormStatus({ type: "success", message: t("Form.submitted") });
      setFormData({ name: "", email: "", phone: "" });
      setTimeout(() => setIsFormOpen(false), 2000);
    } catch (error) {
      setFormStatus({
        type: "error",
        message: error.response?.data?.error || t("Form.error"),
      });
    }
  };

  return (
    <div className="popup-overlay" onClick={handleCloseClick}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={handleCloseClick}>
          ×
        </button>

        <div className="popup-body">
          <div className="popup-image">
            <img src={product.image} alt={product.name} />
          </div>

          <div className="popup-details">
            <h2>{product.name}</h2>
            <p className="product-description">{product.description}</p>

            <div className="info-section">
              {product.length && (() => {
                const info = splitInfo(product.length);
                return (
                  <div className="info-item">
                    <span className="info-label">{info.label || "Length"}:</span>
                    <span className="info-value">{info.value}</span>
                  </div>
                );
              })()}
              {product.diameter && (() => {
                const info = splitInfo(product.diameter);
                return (
                  <div className="info-item">
                    <span className="info-label">{info.label || "Diameter"}:</span>
                    <span className="info-value">{info.value}</span>
                  </div>
                );
              })()}
              {product.leength && (() => {
                const info = splitInfo(product.leength);
                return (
                  <div className="info-item">
                    <span className="info-label">{info.label || "Type"}:</span>
                    <span className="info-value">{info.value}</span>
                  </div>
                );
              })()}
              {product.description1 && (() => {
                const info = splitInfo(product.description1);
                return (
                  <div className="info-item">
                    <span className="info-label">{info.label || "Description 1"}:</span>
                    <span className="info-value">{info.value}</span>
                  </div>
                );
              })()}
              {product.description2 && (() => {
                const info = splitInfo(product.description2);
                return (
                  <div className="info-item">
                    <span className="info-label">{info.label || "Description 2"}:</span>
                    <span className="info-value">{info.value}</span>
                  </div>
                );
              })()}
              {product.description3 && (() => {
                const info = splitInfo(product.description3);
                return (
                  <div className="info-item">
                    <span className="info-label">{info.label || "Description 3"}:</span>
                    <span className="info-value">{info.value}</span>
                  </div>
                );
              })()}
              {product.description4 && (() => {
                const info = splitInfo(product.description4);
                return (
                  <div className="info-item">
                    <span className="info-label">{info.label || "Description 4"}:</span>
                    <span className="info-value">{info.value}</span>
                  </div>
                );
              })()}
              {product.description5 && (() => {
                const info = splitInfo(product.description5);
                return (
                  <div className="info-item">
                    <span className="info-label">{info.label || "Description 5"}:</span>
                    <span className="info-value">{info.value}</span>
                  </div>
                );
              })()}
              {product.description6 && (() => {
                const info = splitInfo(product.description6);
                return (
                  <div className="info-item">
                    <span className="info-label">{info.label || "Description 6"}:</span>
                    <span className="info-value">{info.value}</span>
                  </div>
                );
              })()}
            </div>

            <button
              className="button-modern quote-btn"
              onClick={() => setIsFormOpen(true)}
            >
              {t("Price.quotation")}
            </button>
          </div>
        </div>
      </div>

      {isFormOpen && (
        <div
          className="form-modal-overlay"
          onClick={() => setIsFormOpen(false)}
        >
          <div
            className="form-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-btn"
              onClick={() => setIsFormOpen(false)}
            >
              ×
            </button>
            <h3>{t("Request.quotation")}</h3>
            <form onSubmit={handleFormSubmit}>
              <div className="form-group">
                <label>{t("Form.name")}</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>{t("Form.email")}</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>{t("Form.phone")}</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <button type="submit" className="button-modern">
                {t("Form.submit")}
              </button>
              {formStatus && (
                <p
                  className={
                    formStatus.type === "success"
                      ? "text-success"
                      : "text-danger"
                  }
                >
                  {formStatus.message}
                </p>
              )}
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default PopupQuickview;